/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_KD_75_68(e) {
  let t = (0, ReactCompiler.c)(13),
    { etiqueta: n, opciones: r, elegida: i, onElegir: a } = e,
    o = (0, React.useRef)(null),
    s;
  t[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((s = () => {
        let e = o.current?.querySelector(`[data-elegida="true"]`);
        typeof e?.scrollIntoView == `function` &&
          e.scrollIntoView({
            block: `center`,
          });
      }),
      (t[0] = s))
    : (s = t[0]);
  let c;
  (t[1] === i ? (c = t[2]) : ((c = [i]), (t[1] = i), (t[2] = c)),
    (0, React.useEffect)(s, c));
  let l;
  if (t[3] !== i || t[4] !== a || t[5] !== r) {
    let e;
    (t[7] !== i || t[8] !== a
      ? ((e = (e) => {
          let t = e === i;
          return (
            <button
              key={e}
              type={`button`}
              role={`option`}
              aria-selected={t}
              data-elegida={t}
              onClick={() => a(e)}
              className={`block w-full py-1.5 text-center text-xs tabular-nums transition ${t ? `bg-(--accent) font-medium text-(--accent-fg)` : `text-(--text-h) hover:bg-(--accent-bg)`}`}
              children={e}
            />
          );
        }),
        (t[7] = i),
        (t[8] = a),
        (t[9] = e))
      : (e = t[9]),
      (l = r.map(e)),
      (t[3] = i),
      (t[4] = a),
      (t[5] = r),
      (t[6] = l));
  } else l = t[6];
  let u;
  return (
    t[10] !== n || t[11] !== l
      ? ((u = (
          <div
            ref={o}
            role={`listbox`}
            aria-label={n}
            className={`scroll-sidebar h-28 w-14 overflow-y-auto rounded-xl border border-(--border)`}
            children={l}
          />
        )),
        (t[10] = n),
        (t[11] = l),
        (t[12] = u))
      : (u = t[12]),
    u
  );
}
